import React from 'react';
import { Table } from '@zillow/constellation';
import { ICheckDisbursementResponse } from '../../../../../types/order/escrow/response/ICheckDisbursementResponse';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';
import { currencyDisplay } from '../../../../../utilities/shared/currencyDisplay';
import { getEscrowBankAccountLabel } from '../../../../../ui-toolkit/utilities/getEscrowBankAccountLabel';
import { propertyAddressToString } from '../../../../../types/address/IPropertyAddressData';
import { useHasFeatureFlag } from '../../../../../selectors/useHasFeatureFlag';

export const CheckDisbursementRow: React.FC<{ item: ICheckDisbursementResponse }> = ({ item }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  return (
    <Table.Row>
      <Table.Cell>{item.checkNumber}</Table.Cell>
      <Table.Cell>{item.name}</Table.Cell>
      <Table.Cell>{item.additionalName}</Table.Cell>
      <Table.Cell>{item.mailingAddress && propertyAddressToString(item.mailingAddress)}</Table.Cell>
      <Table.Cell>{currencyDisplay(item.amountCents, true)}</Table.Cell>
      <Table.Cell>{item.memo}</Table.Cell>
      <Table.Cell>{item.category}</Table.Cell>
      <Table.Cell>{item.escrowBankAccount && getEscrowBankAccountLabel(item.escrowBankAccount, isSpruceWithZillowEnabled, isZillowClosingEnabled)}</Table.Cell>
      <Table.Cell>{item.escrowBankAccount?.accountNumber}</Table.Cell>
      <Table.Cell>{item.wellsFargoTransactionNumber}</Table.Cell>
      <Table.Cell>{item.wellsFargoPaymentManagerDeliveryCodeLabel}</Table.Cell>
      <Table.Cell>{item.sentAt && getDateString(DateFormat.hugeDateTime, item.sentAt, true)}</Table.Cell>
      <Table.Cell>{item.completedAtDate && getDateString(DateFormat.hugeDate, item.completedAtDate)}</Table.Cell>
      <Table.Cell>
        {item.enqueuedForDisbursementAt && getDateString(DateFormat.hugeDateTime, item.enqueuedForDisbursementAt, true)}
      </Table.Cell>
    </Table.Row>
  );
};
